import React from 'react'
import { Container } from 'react-bootstrap'

import img_analuisa from '../../../assets/img/founders/ana-luisa.jpg'
import img_carolina from '../../../assets/img/founders/carolina.png'
import img_victoria from '../../../assets/img/founders/victoria.png'

// Styles
import '../../../styles/quienessomos/founders.styles.scss'
import SubHeading from '../../subHeading/SubHeading'

const founders = [
    {
        name: 'Carolina Ackermann Barreiro',
        project: 'Proyecto Mujer Sin Reglas',
        image: img_carolina,
        alt: 'Carolina Ackermann Barreiro',
        modifier: 'founder-card__image--carolina',
    },
    {
        name: 'Mª Victoria López Benito',
        project: 'Proyecto Hystera. Salud Femenina',
        image: img_victoria,
        alt: 'Mª Victoria López Benito',
        modifier: 'founder-card__image--victoria',
    },
    {
        name: 'Ana Luisa Meza Ferrari',
        project: 'Proyecto Psicoutera',
        image: img_analuisa,
        alt: 'Ana Luisa Meza Ferrari',
        modifier: 'founder-card__image--ana',
    },
]

const Founders = () => {

    return (
        <Container fluid className='founders founders--profiles'>
            <div className='founders__header'>
                <SubHeading title='Fundadoras' color={true} />
                <p className='founders__intro p__main'>
                    La Vida en Rojo fue impulsada por Carolina Ackermann Barreiro, Mª Victoria López Benito y Ana Luisa Meza Ferrari, tres mujeres con saberes y recorridos vitales distintos, unidas por la misma certeza: que el conocimiento menstrual es una herramienta de transformación personal y colectiva, vinculada a los derechos humanos y al cuidado de los ecosistemas.
                </p>
            </div>

            <div className='founders__profiles-grid'>
                {founders.map((founder) => (
                    <article className='founder-card' key={founder.name}>
                        <div className='founder-card__image-wrap'>
                            <img
                                className={`founder-card__image ${founder.modifier}`}
                                alt={founder.alt}
                                src={founder.image}
                            />
                        </div>
                        <div className='founder-card__body'>
                            <h3>{founder.name}</h3>
                            <p>{founder.project}</p>
                        </div>
                    </article>
                ))}
            </div>
        </Container>
    )
}

export default Founders
